<template>
  <div>
    <div class="panel-list">
      <div class="panel panel-clickable">
        <div class="panel-body flex">
          <content-loader height="8.5" primary-color="#F2F7FD" secondary-color="#E0EDFB">
            <rect y="0" x="5" width="49%" height="8.5"/>
            <rect y="0" x="50%" width="48%" height="8.5"/>
          </content-loader>
        </div>
      </div>
      <div class="panel panel-clickable">
        <div class="panel-body flex">
          <content-loader height="8.5" primary-color="#F2F7FD" secondary-color="#E0EDFB">
            <rect y="0" x="5" width="49%" height="8.5"/>
            <rect y="0" x="50%" width="48%" height="8.5"/>
          </content-loader>
        </div>
      </div>
      <div class="panel panel-clickable">
        <div class="panel-body flex">
          <content-loader height="8.5" primary-color="#F2F7FD" secondary-color="#E0EDFB">
            <rect y="0" x="5" width="49%" height="8.5"/>
            <rect y="0" x="50%" width="48%" height="8.5"/>
          </content-loader>
        </div>
      </div>
      <div class="panel panel-clickable">
        <div class="panel-body flex">
          <content-loader height="8.5" primary-color="#F2F7FD" secondary-color="#E0EDFB">
            <rect y="0" x="5" width="49%" height="8.5"/>
            <rect y="0" x="50%" width="48%" height="8.5"/>
          </content-loader>
        </div>
      </div>
      <div class="panel panel-clickable">
        <div class="panel-body flex">
          <content-loader height="8.5" primary-color="#F2F7FD" secondary-color="#E0EDFB">
            <rect y="0" x="5" width="49%" height="8.5"/>
            <rect y="0" x="50%" width="48%" height="8.5"/>
          </content-loader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
  name: "SolutionEditorLoadingIndicator",
  components: { ContentLoader },
  props: {height: {type: Number, default: 600}},
};
</script>

<style scoped>
  .flex {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .panel-list {
    margin: 0 1.5rem;
    max-width: 120rem;
  }
</style>